import { render } from "./FormChecksRadiosPage.vue?vue&type=template&id=a096404a&ts=true"
import script from "./FormChecksRadiosPage.vue?vue&type=script&lang=ts"
export * from "./FormChecksRadiosPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__